require('./newTransactionContainer.scss')

module.exports = {
  template: require('./newTransactionContainer.pug')()
  controller: require('./newTransactionContainer.ctrl')
}
